import React from 'react'
import CardSimple from 'screens/components/basic/CardSimple';

const Twilio = () => {
    return (
        <div id="twilio-setup">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to set up Twilio account</h2>
                        <a href="https://www.twilio.com/sms/pricing/ca" target="_blank">Link: Twilio Price Strategy</a>
                        <p><strong>NOTE:</strong> This documentation will walk you through on how to create and set up twilio account by yourself.</p>
                        <ul>
                            <li>Go to <a href="https://www.twilio.com/try-twilio" target="_blank">https://www.twilio.com/try-twilio</a> and sign up.</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/signup_DPI72_min.jpg" width="500" />
                            <li>Select configurations based on the image below.</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/about.png" width="500" />
                            <li>You will get your SID and Auth Token in your dashbord/console. (Both are needed for TechPOS)</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/get_number.png" width="800" />
                            <li>Click "Get a Twilio phone number", then you will see your phone number in your console as well.(Needed for TechPOS)</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/get_info.png" width="800" />
                            <li>You also need to upgrade to a paid account to get rid of "Sent from your Twilio trial account" message and get full usage for the service.</li>
                            <li>For details on how to upgrade to a paid twilio account, please go here: <a href="https://support.twilio.com/hc/en-us/articles/223183208-Upgrading-to-a-paid-Twilio-Account" target="_blank">https://support.twilio.com/hc/en-us/articles/223183208-Upgrading-to-a-paid-Twilio-Account</a></li>
                            <li>You may also receive an email from Twilio that let you answer some questions from them, please reply the email as well.</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/upgrade_email.png" width="1200" />
                            <li>In our marketing tab, click the "Update Twilio Credentials" button and fill up your SID, Auth Token and phe number.</li>
                            <img src="https://techposdev.blob.core.windows.net/supportdocimages/update_twilio.png" width="800" />
                            <li>You can also send a test message by using the "Send Test Message" button.</li>
                            <li>
                                Other useful links:
                                <br />
                                <a href="https://support.twilio.com/hc/en-us/articles/223136027-Auth-Tokens-and-How-to-Change-Them" target="_blank">How to find SID and Auth-Tokens</a>
                                <br />
                                <a href="https://support.twilio.com/hc/en-us/articles/223135247-How-to-Search-for-and-Buy-a-Twilio-Phone-Number-from-Console" target="_blank">How to buy a phone number</a>
                                <br />
                            </li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default Twilio;